/* AURA Fs ‚Äî JS V2 (CRO patterns) */
(function () {
  const page = document.querySelector('.fs-page');
  if (!page) return;

  /* 1) Galer√≠a: thumbs + prev/next */
  const mainImg = page.querySelector('#FsMainImg');
  const thumbs  = page.querySelectorAll('.fs-thumb');
  let idx = 0;

  const setIdx = (i) => {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    thumbs.forEach(t => t.classList.remove('active'));
    thumbs[i].classList.add('active');
    if (mainImg) mainImg.src = thumbs[i].dataset.src;
    idx = i;
  };

  thumbs.forEach((t, i) => t.addEventListener('click', () => setIdx(i)));
  page.querySelector('.fs-prev')?.addEventListener('click', () => setIdx(idx - 1));
  page.querySelector('.fs-next')?.addEventListener('click', () => setIdx(idx + 1));

  /* 2) Selector de color ‚Üí busca variante real Shopify */
  const colorOpts = page.querySelectorAll('.fs-color-opt');
  const variantInput = page.querySelector('#FsVariantId');
  const productHandle = (location.pathname.match(/products\/([^/]+)/) || [])[1];
  let productData = null;
  if (productHandle) {
    fetch(`/products/${productHandle}.js`).then(r => r.json()).then(d => {
      productData = d;
      updateCartPrice();
    }).catch(()=>{});
  }

  colorOpts.forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.fs-color-options');
      wrapper.querySelectorAll('.fs-color-opt').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const selectedValueSpan = page.querySelector('.fs-selected-value');
      if (selectedValueSpan) selectedValueSpan.textContent = btn.dataset.value;
      if (!productData) return;

      const selected = [];
      page.querySelectorAll('.fs-color-options').forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const active = group.querySelector('.fs-color-opt.active');
        if (active) selected[pos - 1] = active.dataset.value;
      });

      const match = productData.variants.find(v =>
        selected.every((val, i) => v[`option${i + 1}`] === val)
      );
      if (match && variantInput) {
        variantInput.value = match.id;
        updateCartPrice(match.price);
      }
    });
  });

  /* 3) Pack selector ‚Üí actualiza precio del CTA, sticky, y saving pill */
  const cartPriceEl = page.querySelector('#FsCartPrice');
  const stickyPriceEl = document.querySelector('.fs-sticky-price');
  const savingPillEl = page.querySelector('#FsSavingPill');
  const stickySaveEl = document.querySelector('#FsStickySave');

  function updateCartPrice() {
    const selected = page.querySelector('.fs-pack-input:checked');
    if (!selected) return;
    const display = selected.dataset.displayPrice;
    const saving  = selected.dataset.saving || '';
    if (display && cartPriceEl) cartPriceEl.textContent = display;
    if (display && stickyPriceEl) stickyPriceEl.textContent = display;
    if (savingPillEl) savingPillEl.textContent = saving;
    if (stickySaveEl) {
      // Version corta para sticky mobile (solo "üéÅ Ahorras $X")
      stickySaveEl.textContent = saving.replace(' con este pack', '');
    }

    page.querySelectorAll('.fs-pack').forEach(p => p.classList.remove('checked'));
    selected.closest('.fs-pack').classList.add('checked');
  }

  page.querySelectorAll('.fs-pack-input').forEach(input => {
    input.addEventListener('change', updateCartPrice);
  });
  updateCartPrice();

  /* 5) Sticky CTA mobile: aparece al scrollear */
  const sticky = document.querySelector('#FsSticky');
  const heroCTA = page.querySelector('#fs-buy');
  if (sticky && heroCTA) {
    const onScroll = () => {
      const rect = heroCTA.getBoundingClientRect();
      const buttonOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      sticky.classList.toggle('fs-visible', buttonOutOfView);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 6) Smooth scroll a #fs-buy */
  page.querySelectorAll('a[href="#fs-buy"]').forEach(a => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      page.querySelector('#fs-buy')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
